// extracted by mini-css-extract-plugin
module.exports = {"insights":"Insights_insights__cByv9"};